<template>
    <div class="question-answer">
        <ul class="has-data">
            <li :class="`data-item data-item${item.id}`" v-for="(item,index) in questionAswList" :key="index">
                <topicContainer
                    :userId="userId"
                    :topicInfo="item"
                    :topIndex="index"
                    :fixedCommentId="fixedCommentId"
                    @tagSelector="tagSelector"
                    @onApproval="onApproval"
                    @onShowAllComment="onShowAllComment"
                    @focusToggle="focusToggle">
                </topicContainer>
            </li>
        </ul>
        <div class="load-more" v-show="questionList.length">
            <img v-if="isLoading" alt="loading" src="../../images/common/loading_2_24x24.gif">
            <p class="no-more" v-else-if="Math.ceil(questionAswList.length / 10) === listCount">没有更多问答了</p>
            <p v-else @click="doLoadMore()">加载更多</p>
        </div>
        <v-alert :options="options"></v-alert>
    </div>
</template>

<script>
import vAlert from '../alert.vue';
import topicContainer from './topicContainer.vue'
export default {
    props: {
        questionList: {
            type: Array,
            default: () => []
        },
        isLogin: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        userId: {
            type: Number,
            default: 0
        },
        listCount: {
            type: Number,
            default: 0
        }
    },
    components: {
        'v-alert': vAlert,
        topicContainer
    },
    data () {
        return {
            options: { // 消息弹窗
                msgText: '',
                msgIsSuccess: true
            },
            questionAswList: [],
            expandedComments: [], // 评论展开id列表
            fixedCommentId: '' // 当定固定的评论id

        }
    },

    filters: {
        transformUnit (val) {
            if (val > 10000) {
                let num = Math.floor( val / 1000 )
                const remainder = val % 1000
                if (remainder > 100) {
                    num += `.${Math.floor(remainder / 100)}`
                }
                return `${num}K`
            }
            return val
        }
    },
    watch: {
        questionList: {
            handler (val) {
                this.questionAswList = val
            },
            immediate: true
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        // 点击热门标签
        tagSelector (item) {
            this.$emit('onSelectCommentTag', item.title);
        },
        // 关注&取消关注
        focusToggle (item) {
            if (!this.isLogin) {
                axios.get(myUrl + 'login/test/')
                return
            }
            let params = {
                topic_id: item.id,
                is_followed: !item.is_followed
            };
            axios.post(myUrl + 'forum/usertopic/', qs.stringify(params)).then((res) => {
                if (res.data.result) {
                    item.is_followed = !item.is_followed;
                    let msg = ''
                    if (item.is_followed) {
                        item.no_of_followed += 1;
                        msg = '关注成功'
                    } else {
                        item.no_of_followed -= 1;
                        msg = '取消关注'
                    }
                    this.$message({
                        message: msg,
                        type: 'success'
                    })
                }
            });
        },
        // 赞同
        onApproval (data) {
            const questionItem = this.questionAswList.find(item => item.id === data.id)
            if (this.isLogin) {
                let params = {
                    action: questionItem.is_approval ? 'down' : 'up',
                    parent_id: questionItem.comment_id
                }
                axios.post(myUrl + 'forum/usercomment/', qs.stringify(params)).then(res => {
                    const index = questionItem.comment_up_list.findIndex(item => item.user_id === this.userId)
                    if (index > -1) {
                        questionItem.comment_up_list.splice(index, 1)
                    } else {
                        questionItem.comment_up_list.push({ user_id: this.userId })
                    }
                    questionItem.is_approval = !questionItem.is_approval
                })
            } else {
                axios.get(myUrl + 'login/test/').then(res => {
                    if (!res.data.result) return;
                    
                });
            }
        },
        // 显示全部评论
        onShowAllComment (id) {
            let isShow = false
            this.questionAswList.some(item => {
                if (item.id === id) {
                    item.isAllComment = !item.isAllComment
                    isShow = item.isAllComment
                    return
                }
            })
            if (!isShow) {
                const el = document.querySelector(`.data-item${id}`)
                const height = el.getBoundingClientRect().top
                const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
                window.scrollTo({
                    top: height + scrollTop - 130,
                    behavior: "smooth"
                })
            }
            const index = this.expandedComments.findIndex(item => item === id)
            if (index > -1) {
                this.expandedComments.splice(index, 1)
            } else {
                this.expandedComments.push(id)
            }
            // 滚动时根据评论高度来设置吸底效果
            this.$nextTick(() => {
                this.handleScroll()
            })
        },
        // 加载更多
        doLoadMore () {
            this.$emit('doLoadMore', true)
        },
        // 监听滚动
        handleScroll () {
            // 处理单个问答评论"收起"吸底
            let fixedId = ''
            this.expandedComments.some(id => {
                const el = document.querySelector(`.data-item${id}`)
                if (el) {
                    const contentEl = el.querySelector('.comment-desc')
                    const { top, bottom, height } = contentEl.getBoundingClientRect()
                    const index = this.questionAswList.findIndex(item => item.id === id)
                    // this.questionAswList[index].fixedBottom = false
                    // "收起"栏吸底需要满足条件：
                    // 评论内容高度超过视口高度；评论内容在视口范围内；评论顶部距视口底部距离超过 200 px
                    if (height > window.innerHeight && bottom > window.innerHeight && top < window.innerHeight - 200) {
                        fixedId = id
                        return true
                    }
                }
            })
            this.fixedCommentId = fixedId
        },
        // 获取吸底“收起”栏的位置坐标
        getCommentCollapsePos () {
            const commentEl = document.querySelector('.comment-content-wrapper')
            const commentWrapperLeft = commentEl.getBoundingClientRect().left
            return { left: `${commentWrapperLeft}px` }
        }
    }
}
</script>

<style lang="scss" scoped>
    .question-answer {
        .has-data {
            .data-item {
                padding: 28px 16px 12px 24px;
                border-bottom: 1px solid #f0f1f5;
                &:first-child {
                    padding-top: 10px;
                }
                &:last-child {
                    border-bottom: none;
                }
            }
        }
        .load-more {
            margin-top: 10px;
            width: 100%;
            height: 42px;
            line-height: 42px;
            color: #828282;
            font-size: 14px;
            background: #fff;
            cursor: pointer;
            outline: none;
            text-align: center;
            .no-more {
                font-size: 12px;
                cursor: default;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// topic.vue?255636b1